import React, { useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import Header from "../../../../../../components/wizard/Header";
import Progress from "../../../../../../components/wizard/Progress";
import PdfGenerateLink from "../../../../../../components/PdfGenerateLink";
import { getWO } from "../../../../utils";
import useMutation from "../../../../../../hooks/useMutation";
import { UPDATE_INVENTORY_REQUEST_MUTATION } from "../../../../../../constants/graphql/mutations";
import { serverFormatSeconds } from "../../../../../../utils/dates";
import useHasAdditionalCharges from "../../../../../../components/capture/ReceivingWizard/hooks/useHasAdditionalCharges";

export default function Confirmation({ project, inventoryRequest, onClose }) {
  const navigate = useNavigate();
  const hasAdditionalCharges = useHasAdditionalCharges(project, "outbound_enabled");
  const [updateInventoryRequest] = useMutation(UPDATE_INVENTORY_REQUEST_MUTATION);

  const moveToItems = () => {
    const pathname = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set("step", "items");
    navigate({ pathname, search: params.toString() });
  };

  useEffect(() => {
    if (!inventoryRequest.pickingCompleteTime) {
      const pickingCompleteTime = moment().format(serverFormatSeconds);
      updateInventoryRequest({
        variables: {
          id: inventoryRequest.id,
          input: { pickingCompleteTime },
        },
      });
    }
  }, []);

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100%">
      <Header title="Confirmation" info={getWO(inventoryRequest)} />
      <Box p={2}>
        <Box mt={3} display="flex" flexDirection="column" alignItems="center">
          <Box
            component="img"
            borderRadius={2}
            width="100%"
            maxWidth={360}
            src="/assets/picked-confirmation.webp"
          />
          <Typography mt={5} px={5} textAlign="center" fontSize={18}>
            Your latest updates have been saved and the appropriate parties have been notified.
          </Typography>
          <Box pt={6}>
            <PdfGenerateLink
              resourceType="inventory_request_pdfs"
              resourceId={inventoryRequest?.id}
              sx={{ textDecoration: "none", fontWeight: 500, fontSize: 16 }}
              label="Outbound Order PDF Receipt"
            />
          </Box>
        </Box>
      </Box>
      <Box mt={2}>
        <Progress step={hasAdditionalCharges ? 4 : 3} steps={hasAdditionalCharges ? 4 : 3} />
        <Box p={2}>
          <Box display="flex" justifyContent="space-between">
            <Button variant="outlined" color="inherit" onClick={moveToItems}>
              Edit Outbound Picking
            </Button>
            <Button onClick={onClose} variant="contained">
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
